import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/checkout/components/Checkout.tsx");
